import type { ErrorComponentProps } from "@tanstack/react-router"
import { Link } from "@tanstack/react-router"
import { Button } from "@/components/shared/buttons/button"
import { ErrorState } from "@/components/shared/errors/error-state"

function isChunkLoadError(error: unknown): boolean {
	if (!(error instanceof Error)) return false
	return (
		error.message.includes("Failed to fetch dynamically imported module") ||
		error.message.includes("dynamically imported module") ||
		error.message.includes("Loading chunk")
	)
}

export function GlobalError({ error, reset }: ErrorComponentProps) {
	if (isChunkLoadError(error)) {
		return (
			<div className="flex h-screen w-full flex-col items-center justify-center gap-y-16 px-12">
				<h1 className="text-4xl text-primary">Update Available</h1>
				<p className="max-w-xl text-center text-lg leading-normal">
					A new version of the app is available. Please refresh to continue.
				</p>
				<Button onClick={() => window.location.reload()}>Refresh</Button>
			</div>
		)
	}

	return (
		<div className="flex h-screen w-full flex-col items-center justify-center gap-y-16 px-12">
			<h1 className="text-4xl text-primary">500</h1>
			<ErrorState
				error={error}
				message="Oops, something went wrong. Please come back later."
				messageClassName="max-w-xl text-lg leading-normal"
			/>
			<div className="flex flex-wrap items-center justify-center gap-3">
				<Button onClick={() => reset()}>Refresh</Button>
				<Link to="/">
					<Button variant="secondary">Take me home</Button>
				</Link>
			</div>
		</div>
	)
}
